import { supabase, publicSupabaseUrl } from './supabase';
import type { BillingSubscription } from './types';

export async function refreshBillingPlanning(billingId: string): Promise<BillingSubscription> {
  const { data } = await supabase!.auth.getSession();
  let result: any;
  let response: Response;
  for (let attempt=0; attempt<2; attempt++) {
  response = await fetch(`${publicSupabaseUrl}/functions/v1/billing-planning-sync?billing_id=${encodeURIComponent(billingId)}`, {
    method: 'POST', headers: { Authorization: `Bearer ${data.session?.access_token}`, 'Content-Type': 'application/json' }, body: '{}',
  });
  result = await response.json();
  if (!result.results?.some((r: any) => r.skipped) || attempt===1) break;
  }
  if (!response!.ok || !result.ok) throw new Error(result.error || result.results?.find((r: any) => !r.ok)?.error || 'De actuele factuurplanning kon niet worden opgehaald.');
  const current = await supabase!.from('billing_subscriptions').select('*,plans(*)').eq('id', billingId).single();
  if (current.error) throw current.error;
  return current.data as BillingSubscription;
}
